import React from "react";
import Loadable from "../../react-loadable";

const WeaAvatar = Loadable({
  loader: () => import("./Avatar"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaAvatar;



// WEBPACK FOOTER //
// ./ecology9/wea-avatar/index.js